var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureFileAddContactActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5142",
    "data-name": "Group 5142",
    transform: "translate(-568 -136)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(568 136)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5141",
    "data-name": "Group 5141",
    transform: "translate(120.375 -0.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add_user",
    "data-name": "Add user",
    transform: "translate(453.025 142.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    d: "M9.551,12.7V11.582A2.244,2.244,0,0,0,7.309,9.34H2.842A2.244,2.244,0,0,0,.6,11.582V12.7",
    transform: "translate(0 -2.031)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    cx: 2.242,
    cy: 2.242,
    r: 2.242,
    transform: "translate(2.834 0.6)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    d: "M10.79.69a2.239,2.239,0,0,1,0,4.337",
    transform: "translate(-2.368 -0.021)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M14.708,6.71V9.827m1.558-1.558H13.15",
    transform: "translate(-2.916 -1.42)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureFileAddContactActive);
export default __webpack_public_path__ + "static/media/secure-file-add-contact-active.9d24d0cce2bf43a41d4c3773e0cad39b.svg";
export { ForwardRef as ReactComponent };